import type {ReactAction} from '@netx/core/bootstrap';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {faArrowDownToBracket} from '@netx/core-icons';
import {canDownloadAsset} from '../enablers';
import {AssetActionLabel} from '../locales';
import {type IAsset} from '../schema';
import {ASSET_EVENT} from './constants';

export const assetActionDownloadIcon = faArrowDownToBracket;

/**
 * Download asset
 * @param params
 * @returns Action
 */
export const assetActionDownload = (
	asset?: IAsset,
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'asset-download',
	cb: () => dispatcher.trigger(ASSET_EVENT.DOWNLOAD, asset?.assetId),
	enableTest: () => canDownloadAsset(asset),
	icon: assetActionDownloadIcon,
	get label() {
		return AssetActionLabel.DOWNLOAD;
	},
	...params,
});

export default assetActionDownload;
